import gql from 'graphql-tag'

const deleteAssenza = gql`
  mutation deleteAssenza($id: Int!) {
    deleteAssenza(id: $id) {
      id
      utenteId
      utente {
        id
        nome
      }
      daDataOra
      aDataOra
      descrizione
      flagOccupato
    }
  }
`

export default deleteAssenza


// WEBPACK FOOTER //
// ./src/graphql/mutations/deleteAssenza.js